import {createContext, Dispatch, SetStateAction, useContext, useMemo, useState} from 'react';

import {ConstructorTab} from '../types';

interface ConstructorContext {
    tab: ConstructorTab;
    setTab?: Dispatch<SetStateAction<ConstructorTab>>;
}

const ConstructorContext = createContext<ConstructorContext>({
    tab: ConstructorTab.Questions
});

export function useCreateConstructorContext(tabId = ConstructorTab.Questions): ConstructorContext {
    const [tab, setTab] = useState(tabId);

    return useMemo(() => ({tab, setTab}), [tab]);
}

export function useConstructorContext() {
    return useContext(ConstructorContext);
}

export const ConstructorProvider = ConstructorContext.Provider;
export const ConstructorConsumer = ConstructorContext.Consumer;
